import { render, staticRenderFns } from "./RoomMessage.vue?vue&type=template&id=adffedb6&scoped=true"
import script from "./RoomMessage.vue?vue&type=script&lang=js"
export * from "./RoomMessage.vue?vue&type=script&lang=js"
import style0 from "./RoomMessage.vue?vue&type=style&index=0&id=adffedb6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adffedb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adffedb6')) {
      api.createRecord('adffedb6', component.options)
    } else {
      api.reload('adffedb6', component.options)
    }
    module.hot.accept("./RoomMessage.vue?vue&type=template&id=adffedb6&scoped=true", function () {
      api.rerender('adffedb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/RoomMessage.vue"
export default component.exports